var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAngR(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Angielski_-_ikona",
    "data-name": "Angielski - ikona",
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .ang-r-1 {\n        fill: #f2af0d;\n      }\n\n      .ang-r-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4939",
    "data-name": "Group 4939",
    transform: "translate(27.857 24.393)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3665",
    "data-name": "Path 3665",
    className: "ang-r-2",
    d: "M520.306,96a33.418,33.418,0,0,0-27.466,52.509l-4.18,16.726a3.186,3.186,0,0,0,4.673,3.538l14.514-8.284a33.02,33.02,0,0,0,12.46,2.424,33.436,33.436,0,0,0,33.074-28.454,2.719,2.719,0,0,0,.061-.476,30.223,30.223,0,0,0,.321-4.526A33.455,33.455,0,0,0,520.306,96Zm29.439,40.528a30.36,30.36,0,0,1-29.439,23.2,28.912,28.912,0,0,1-8.825-1.338c-.834-.24-1.655-.512-2.456-.826a3.211,3.211,0,0,0-2.782.167l-1.932,1.106L491.758,166l3.566-14.307.6-2.367a3.2,3.2,0,0,0-.5-2.615,27.013,27.013,0,0,1-1.529-2.444,30.3,30.3,0,0,1,10.1-40.3,25.871,25.871,0,0,1,3.794-2.07c.094-.065.191-.1.285-.159a25.016,25.016,0,0,1,3.505-1.244,29.487,29.487,0,0,1,8.731-1.305,30.3,30.3,0,0,1,30.268,30.268c0,.732-.033,1.464-.093,2.168A27.762,27.762,0,0,1,549.745,136.526Z",
    transform: "translate(-486.85 -95.998)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4938",
    "data-name": "Group 4938",
    transform: "translate(7.718 25.262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3666",
    "data-name": "Path 3666",
    className: "ang-r-2",
    d: "M498.487,104.572h-5.392v3.558h4.787v2.261h-4.787v3.766h5.392v2.322h-8.239V102.25h8.239Z",
    transform: "translate(-490.248 -102.087)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3667",
    "data-name": "Path 3667",
    className: "ang-r-2",
    d: "M505.055,102.25v14.229h-2.847l-6.454-9.752v9.752h-2.847V102.25h2.847l6.454,9.768V102.25Z",
    transform: "translate(-482.091 -102.087)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3668",
    "data-name": "Path 3668",
    className: "ang-r-2",
    d: "M510.271,106.667h-3.278a3.572,3.572,0,0,0-3.335-1.834c-2.546,0-4.315,1.814-4.315,4.644,0,2.891,1.789,4.681,4.437,4.681a3.857,3.857,0,0,0,4.03-3.278h-4.888V108.7h7.7v2.481a6.945,6.945,0,0,1-6.942,5.535,7.255,7.255,0,1,1-.02-14.51C506.831,102.21,509.356,103.816,510.271,106.667Z",
    transform: "translate(-471.345 -102.21)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    "data-name": "Union 4",
    className: "ang-r-2",
    d: "M4.147,10.664V6.514H0V4.146H4.147V0H6.516V4.146h4.146V6.514H6.516v4.15Z",
    transform: "translate(50.109 27.188)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngR);
export default __webpack_public_path__ + "static/media/ang-r.440741e8e117325d8ff400d0dac882ec.svg";
export { ForwardRef as ReactComponent };